"use client";
import PopUp from "../pop-up-helpers/PopUp";
import ProductPriceInfo from "../../product/product-box/product-box-helpers/product-price-info/ProductPriceInfo";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { Button } from "react-bootstrap";
import CanselIcon from "./CanselIcon";
import useProductPriceInfoPopup from "@/hooks/useProductPriceInfoPopup";

const ProductPriceInfoPopUp = () => {
  const { handleCloseProductInfoPopup, popupValue, priceInfo } =
    useProductPriceInfoPopup();
  const t = useTranslation();
  return (
    <PopUp
      isOpen={!!popupValue}
      onClose={handleCloseProductInfoPopup}
      contentClassName="product-price-info-popup-width"
    >
      <div className="product-price-info-popup">
        <div
          role="button"
          onClick={handleCloseProductInfoPopup}
          style={{ alignSelf: "end" }}
        >
          <CanselIcon />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p className="title"> {t.spiceal_prices}</p>
        </div>
        <ProductPriceInfo productSpecialPrices={priceInfo!} />
        <Button
          variant="outline-dark"
          style={{ width: "90%", paddingInline: 15 }}
          color="black"
          onClick={handleCloseProductInfoPopup}
        >
          Close
        </Button>
      </div>
    </PopUp>
  );
};

export default ProductPriceInfoPopUp;
